// extracted by mini-css-extract-plugin
module.exports = {"commentCard":"commentCard--zOEO6","avatar":"avatar--Rfz8b","postHeader":"postHeader--BAx0O","createdDate":"createdDate--wlY8c","text":"text--WSUP6"};